import {Button, Form, Image, Input, Spin, Typography} from "antd";
import {Callbacks} from "rc-field-form/lib/interface";
import ReCAPTCHA from "react-google-recaptcha";
import Logo from "../assets/logo.jpg"
import React from "react";
import variables from "../common/variables";

interface Props {
    spinning: boolean;
    onFinish: Callbacks['onFinish'];
    setChallenge: React.Dispatch<React.SetStateAction<"FORGOT_PASSWORD" | "SIGN-IN" | "NEW_PASSWORD_REQUIRED">>;
    onFinishFailed: Callbacks['onFinishFailed'];
    recaptchaRef: any;
}

const {Title} = Typography;

const SignInForm = ({spinning, onFinish, onFinishFailed, setChallenge, recaptchaRef}: Props) => {
    const [form] = Form.useForm();
    return (
        <Spin tip="Loading..." spinning={spinning}>
            <Form
                form={form}
                style={{height: "100%"}}
                name="basic"
                labelAlign={"left"}
                wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item>
                    <Title level={4} type="secondary" style={{textAlign: "center"}}>Advanced Clean Trucks Reporting System (ACTRS)</Title>
                    <Image
                        preview={false}
                        width={"100%"}
                        src={Logo}
                    />
                </Form.Item>
                <Form.Item
                    name="email"
                    hasFeedback
                    rules={[{required: true, type: 'email', message: 'Invalid email address!'}]}
                >
                    <Input placeholder="Email"/>
                </Form.Item>

                <Form.Item
                    hasFeedback
                    name="password"
                    rules={[{required: true, message: 'Please input your password!'}]}
                >
                    <Input.Password placeholder="Password"/>
                </Form.Item>


                <Form.Item name="captcha" hasFeedback rules={[{required: true, message: 'Complete captcha!'}]}>
                    <ReCAPTCHA
                        onChange={(ev) => form.setFieldsValue({captcha: ev})}
                        sitekey={variables.captchaKey!}
                        ref={el => recaptchaRef.current[0] = el}
                    />
                </Form.Item>

                <Form.Item wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}>
                    <Button style={{width: "100%"}} type="primary" htmlType="submit">
                        Sign In
                    </Button>
                </Form.Item>

                <Form.Item wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}>
                    <Button style={{width: "100%"}} type="link" onClick={() => setChallenge("FORGOT_PASSWORD")}>
                        Forgot password ?
                    </Button>
                </Form.Item>
            </Form>
        </Spin>

    )
}

export default SignInForm;
